module.exports = "<ng-content></ng-content> <div #googleMapContainer class=google-map-container></div> ";